import React, { Component } from "react";
import "./blog.css";
import firebase from "firebase";
import Loader from "../../../../components/loader/loader";
export default class SectionBlog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      blogs: [],
      loading: true,
    };
  }

  componentDidMount() {
    if (this.state.loading) {
      document.body.style.overflowY = "hidden";
    }
    firebase
      .firestore()
      .collection("blog")
      .onSnapshot((snap) => {
        snap.docChanges().forEach((changes) => {
          var blog = changes.doc.data();
          blog.id = changes.doc.id;
          this.setState({
            blogs: [...this.state.blogs, blog],
          });
        });
        this.setState(
          {
            loading: false,
          },
          () => {
            document.body.style.overflowY = "scroll";
          }
        );
      });
  }

  render() {
    return (
      <>
        {this.state.loading ? (
          <Loader />
        ) : (
          <div>
            <div className="fourthsec">
                <h1>BLOG</h1>
              <div className="main-4">
              <h3>Check Out Our latest Blog</h3> 
                <div className="elements">
                  {this.state.blogs.map((blog) => {
                    return (
                      <a href={"/blog/" + blog.id} className=" element">
                        <img
                          src={blog.thumbnail}
                          alt=""
                          className="subackground1"
                        ></img>
                        <img
                          src={blog.thumbnail}
                          alt=""
                          className="subelement1"
                        ></img>
                        <div className="subelement2">
                          <h6>{blog.title}</h6>
                        </div>
                      </a>
                    );
                  })}
                </div>
              </div>
              <a href="/blog" className="seemore">see more</a>
            </div>
          </div>
        )}
      </>
    );
  }
}
